import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-default-card-body',
  templateUrl: './default-card-body.component.html',
  styleUrls: ['./default-card-body.component.css']
})
export class DefaultCardBodyComponent {
  constructor(private router: Router){}
  
  goToHome(){
    this.router.navigate(['/']);
  }
}
